import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import availabilitySlice from 'store/modules/availability';

const useAvailabilityRepeat = () => {
  const dispatch = useDispatch();
  const trainerId = useSelector((state) => state.auth.user.id);

  /**
   * Repeats availabilities from the current week to the next 8 weeks using the backend mutation.
   *
   * @callback handleRepeat
   * @param  {Object}  dateRange  The date range of the current week.
   */
  const handleRepeat = useCallback(
    (dateRange) => {
      // Use the start of the week as source_date (backend will look for all availabilities in that week)
      const sourceDate = format(new Date(dateRange.startDate), 'yyyy-MM-dd');

      // Calculate repeat_until date (8 weeks from source date)
      const repeatUntilDate = new Date(dateRange.startDate);
      repeatUntilDate.setDate(repeatUntilDate.getDate() + (8 * 7)); // 8 weeks = 56 days
      const repeatUntil = format(repeatUntilDate, 'yyyy-MM-dd');

      // Prepare the input for the backend mutation
      const input = {
        user_id: Number(trainerId),
        source_date: sourceDate,
        repeat_until: repeatUntil,
        repeat_type: 'WEEKLY' // Repeat on the same day of week
      };

      // Dispatch the repeat action with the input
      dispatch(availabilitySlice.actions.repeat({ input, userId: trainerId }));
    },
    [dispatch, trainerId]
  );

  return {
    handleRepeat
  };
};

export default useAvailabilityRepeat;
